/**
 * Product Families Action Types
 */

export const SET_PRODUCT_FAMILIES = 'SET_PRODUCT_FAMILIES';
export const SET_PRODUCT_FAMILIES_LOADING = 'SET_PRODUCT_FAMILIES_LOADING';
export const SET_PRODUCT_FAMILIES_ERROR = 'SET_PRODUCT_FAMILIES_ERROR';
export const SET_ACTIVE_FAMILY = 'SET_ACTIVE_FAMILY';
export const ADD_PRODUCT_FAMILY = 'ADD_PRODUCT_FAMILY';
export const UPDATE_PRODUCT_FAMILY = 'UPDATE_PRODUCT_FAMILY';
export const DELETE_PRODUCT_FAMILY = 'DELETE_PRODUCT_FAMILY';
export const SET_SELECTED_FAMILY_FILTER = 'SET_SELECTED_FAMILY_FILTER';
